import { render } from "./PageNotFound.vue?vue&type=template&id=a31644e2&scoped=true"
const script = {}

import "./PageNotFound.vue?vue&type=style&index=0&id=a31644e2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a31644e2"]])

export default __exports__